import React from "react"
import { withTheme } from "emotion-theming"
import styled from "@emotion/styled"
import VisuallyHidden from "@reach/visually-hidden"

import { ViewButton } from "@components/button"
import { Container, Row, Col } from "@components/grid"
import { Heading, HeadingTwo } from "@components/type"

import { staff, board } from "@data"
import { rhythm } from "@utils/typography"

const Wrapper = styled.section`
  padding: ${rhythm(4)} 0;
`
const sectionTitle = "Staff & Board"

const Staff = ({ theme }) => (
  <Wrapper>
    <VisuallyHidden>
      <Heading>{sectionTitle}</Heading>
    </VisuallyHidden>
    <Container maxWidth="1200px">
      <HeadingTwo colour={theme.colours.primary}>Staff</HeadingTwo>
      <Row mb={4}>
        {staff.map(person => (
          <Col key={person.name} width={1 / 2}>
            <strong>{person.name}</strong> | {person.title}
          </Col>
        ))}
      </Row>
      <HeadingTwo colour={theme.colours.primary}>Board of Directors</HeadingTwo>
      <Row mb={3}>
        {board.map(person => (
          <Col key={person.name} width={1 / 2}>
            <strong>{person.name}</strong> | {person.title}
          </Col>
        ))}
      </Row>
      <ViewButton to="/staff-board" colour={theme.colours.primary}>
        View
        <VisuallyHidden> {sectionTitle}</VisuallyHidden>
      </ViewButton>
    </Container>
  </Wrapper>
)

export default withTheme(Staff)
